<template>
  <div class="flex justify-center items-center">
    <slot />
  </div>
</template>

<script setup>

</script>
